import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="224520" id="cart-content" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 min-h-[70vh] flex flex-col">
      <div className="w-full max-w-7xl mx-auto flex-1 flex flex-col">
        <div className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold font-default tracking-tight mb-4 text-foreground">
            Your SurfPup Gear
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Review your handcrafted beach-inspired collars and coastal accessories before heading to the checkout.
          </p>
        </div>

        {}
        <div className="bg-card text-foreground rounded-lg shadow-lg p-6 md:p-10 lg:p-12 w-full flex-1 border border-border">
          <div className="max-w-5xl mx-auto">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}